import { RUN_RATE_SCHEDULE_TYPE } from '../expenseForecast.js';
function treeIds(ownership) {
    const portfolios = ownership.portfolios;
    const properties = portfolios.flatMap((p) => p.properties);
    const units = properties.flatMap((p) => p.units);
    return {
        ownership: ownership.id,
        portfolios: new Set(portfolios.map((p) => p.id)),
        properties: new Set(properties.map((p) => p.id)),
        units: new Set(units.map((u) => u.id)),
        displayIds: new Set([
            ownership.displayId,
            ...portfolios.map((p) => p.displayId),
            ...properties.map((p) => p.displayId),
            ...units.map((u) => u.displayId),
        ]),
    };
}
function entityDisplayId(entity) {
    switch (entity.type) {
        case 'ownership':
            return entity.ownershipId;
        case 'portfolio':
            return entity.portfolioId;
        case 'property':
            return entity.propertyId;
        case 'unit':
            return entity.unitId;
        default: {
            const _exhaustive = entity;
            throw new Error(`Unhandled schedule entity: ${JSON.stringify(_exhaustive)}`);
        }
    }
}
export function projectionSchedulesFromRouter(incomeStructures, incomeSchedules, expenseSchedules, ownershipDisplayId) {
    const structure = incomeStructures.find((s) => s.ownership.displayId === ownershipDisplayId);
    if (structure === undefined)
        return { kind: 'unreadable' };
    const ids = treeIds(structure.ownership);
    const income = incomeSchedules.filter((s) => s.status === 'active' &&
        (s.ownershipId === ids.ownership ||
            (s.portfolioId !== null && ids.portfolios.has(s.portfolioId)) ||
            (s.propertyId !== null && ids.properties.has(s.propertyId)) ||
            (s.unitId !== null && ids.units.has(s.unitId))));
    const schedules = [
        ...income.map((s) => ({
            ref: { direction: 'income', displayId: s.displayId, name: s.name },
            spec: s.scheduleSpec,
        })),
        ...expenseSchedules
            .filter((s) => s.status === 'active' && ids.displayIds.has(entityDisplayId(s.entity)))
            .map((s) => ({
            ref: {
                direction: 'expense',
                displayId: s.displayId,
                name: s.name,
                runRate: s.type === RUN_RATE_SCHEDULE_TYPE,
            },
            spec: s.scheduleSpec,
        })),
    ];
    return {
        kind: 'schedules',
        schedules,
        incomeTypes: new Map(income.map((s) => [s.displayId, s.type])),
        units: ids.units.size,
    };
}
//# sourceMappingURL=routerSchedules.js.map